export const LOGICAL_OPERATORS = {
  AND: 'AND',
  OR: 'OR',
} as const;

export const FILTER_QUERY_VALUE_TYPES = {
  STRING: 'string',
  NUMBER: 'number',
  DISTANCE: 'distance',
  AREA: 'area',
  VOLUME: 'volume',
  ANGLE: 'angle',
  BOOLEAN: 'boolean',
  ROUGHNESS: 'roughness',
} as const;

export const FILTER_UNITS = {
  MM: 'mm',
  IN: 'in',
  DEG: 'deg',
} as const;

export const COUNT_OPERATORS = {
  EQUALS: 'equals',
  NOT_EQUALS: 'notEquals',
  GREATER_THAN: 'greaterThan',
  GREATER_THAN_OR_EQUAL: 'greaterThanOrEqual',
  LESS_THAN: 'lessThan',
  LESS_THAN_OR_EQUAL: 'lessThanOrEqual',
  RANGE: 'range',
} as const;

// TODO: implement these with frontend query builder system
export const NUMERIC_ONLY_OPERATORS = {
  ON_INTERVAL: 'onInterval',
  NOT_ON_INTERVAL: 'notOnInterval',
} as const;

export const NUMERIC_OPERATORS = {
  ...COUNT_OPERATORS,
} as const;

export const STRING_OPERATORS = {
  INCLUDES: 'includes',
  INCLUDES_CASE_INSENSITIVE: 'includesCaseInsensitive',
  REGEX: 'regex',
} as const;

export const SELECT_OPERATORS = {
  IS_IN: 'isIn',
  NOT_IN: 'notIn',
} as const;

export const NULL_OPERATORS = {
  IS_NULL: 'isNull',
} as const;

export const OPERATORS = {
  ...NUMERIC_OPERATORS,
  ...STRING_OPERATORS,
  ...SELECT_OPERATORS,
  ...NULL_OPERATORS,
} as const;

export const CALLOUT_TYPES = {
  DATUM: 'datum',
  DIM: 'dim',
  HOLE: 'hole',
  COUNTERSINK: 'countersink',
  COUNTERBORE: 'counterbore',
  CONTROL_FRAME: 'control_frame',
  COMPOSITE_CONTROL_FRAME: 'composite_control_frame',
} as const;

export const REQS_REVIEW_CONFIG_ITEM_FILTER_TYPES = {
  NUMERIC: 'numeric',
  SELECT: 'select',
  STRING: 'string',
  BOOLEAN: 'boolean',
} as const;

export const RESOLUTION_RELATED_DB_ENTITY_TYPES = {
  OP_DEF: 'OP_DEF',
  PROCESS: 'PROCESS',
  USER: 'USER',
  QUOTE_WORKFLOW_STEP: 'QUOTE_WORKFLOW_STEP',
} as const;

export const RESOLUTION_PARAMETER_TYPES = {
  BOOLEAN: 'BOOLEAN',
  STRING: 'STRING',
  NUMERIC: 'NUMERIC',
  NUMERIC_LIST: 'NUMERIC_LIST',
} as const;

export const RESOLUTION_VALIDATION_CONDITIONS = {
  PROCESS_REQUIRED: 'PROCESS_REQUIRED',
  NO_MULTI_COMPONENT_NEST: 'NO_MULTI_COMPONENT_NEST',
} as const;

export const REQS_REVIEW_RESOLUTION_TYPES = {
  ADD_OPERATION: 'ADD_OPERATION',
  ASSIGN_ESTIMATOR: 'ASSIGN_ESTIMATOR',
  SET_PROCESS: 'SET_PROCESS',
  UPDATE_WORKFLOW_STEP: 'UPDATE_WORKFLOW_STEP',
  START_CHAT: 'START_CHAT',
  NO_QUOTE: 'NO_QUOTE',
  RESOLVE: 'RESOLVE',
} as const;

export const FILTER_WIDGET_TYPES = {
  ACCOUNT: 'account',
  PROCESS: 'process',
  FACILITY: 'facility',
} as const;
